import { createTheme, MantineColorsTuple } from "@mantine/core"

const orGreen: MantineColorsTuple = [
  "#eaf8ef",
  "#d3f0de",
  "#a8e0be",
  "#74cc98",
  "#4db978",
  "#38b46b",
  "#2c9a58",
  "#20824a",
  "#1a6b3e",
  "#145533"
]

export const orTheme = createTheme({
  primaryColor: "orGreen",
  colors: { orGreen },
  fontFamily:
    'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  headings: {
    fontWeight: "800",
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'
  },
  defaultRadius: "md",
  black: "#17231f",
  white: "#ffffff",
  cursorType: "pointer"
})
